import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import SetVariableMutation from '../../mutations/SetVariable';
import GameQuery from '../../query/GameQuery';

class CheckButton extends Component {
	render() {
		const { variable } = this.props;
		return (
			<GameQuery>
				{
					query => (
						<SetVariableMutation>
							{setVariable => (
								<div
									onClick={() =>
										this.handleClick(setVariable, !variable.value ? 1 : 0, query.game)
									}
									className={`check-button ${
										!variable.disabled
											? 'check-button-active'
											: 'check-button-disabled'
									}`}
								>
									{variable.value === 1 && <div className="check-button-content" />}
								</div>
							)}
						</SetVariableMutation>
					)
				}
			</GameQuery>
		);
	}
	handleClick(setVariable, value,game) {
		const { variable } = this.props;
		const {
			name,
			year,
		} = variable;
		!variable.disabled &&
			setVariable({
				variables: {
					gameID: game.id,
					submission:game.lastSubmission,
					name,
					year,
					value
				}
			});
	}
}

CheckButton.propTypes = {
	variable: PropTypes.object
};

export default CheckButton;
